import {
	EActionState,
	ICampaignSetting,
	IRegion,
	IRegionCampaign,
	IRegionCampaignUpdate
} from '@/models';

export interface IRegionCampaignState {
	region: IRegion;
	regionCampaign: {
		data: IRegionCampaign;
		loaded: EActionState;
	};
	regionCampaigns: {
		data: IRegionCampaign[];
		loaded: EActionState;
	};
	regionCampaignUpdate: {
		data: IRegionCampaignUpdate | null;
		loaded: EActionState;
	};
	regionCampaignUpdates: {
		data: IRegionCampaignUpdate[];
		loaded: EActionState;
	};
	campaignSettings: ICampaignSetting[];
	campaignSetting: ICampaignSetting | null;
	regionsByCampaign: IRegionCampaign[];
}

export const initialState: IRegionCampaignState = {
	region: {
		company: '',
		businessUnit: '',
		serviceRegion: ''
	},
	regionCampaign: {
		data: {
			company: '',
			businessUnit: '',
			serviceRegion: '',
			campaigns: []
		},
		loaded: EActionState.PENDING
	},
	regionCampaigns: {
		data: [],
		loaded: EActionState.PENDING
	},
	regionCampaignUpdate: {
		data: null,
		loaded: EActionState.PENDING
	},
	regionCampaignUpdates: {
		data: [],
		loaded: EActionState.PENDING
	},
	campaignSettings: [],
	campaignSetting: null,
	regionsByCampaign: []
};
